import { render } from "./P_Greatsword.vue?vue&type=template&id=13fae0ad&scoped=true"
import script from "./P_Greatsword.vue?vue&type=script&lang=js"
export * from "./P_Greatsword.vue?vue&type=script&lang=js"

import "./P_Greatsword.vue?vue&type=style&index=0&id=13fae0ad&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fae0ad"]])

export default __exports__